import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export const useCheckUserAuth = (status) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (status === "unauthorized") {
      navigate("/login");
    }
  }, [status, navigate]);
};
